export type DocumentType =
  | "intake_form"
  | "medical_records"
  | "clinical_evidence"
  | "criteria_information"
  | "appointment_of_representative_form"
  | "supporting_statement"
  | "independent_review_entity_response"
  | "general_communication"
  | "external_review_case_summary";

export const DOCUMENT_TYPE_LABEL: Record<DocumentType, string> = {
  intake_form: "Intake Form",
  medical_records: "Medical Records",
  clinical_evidence: "Clinical Evidence",
  criteria_information: "Criteria Information",
  appointment_of_representative_form: "Appointment of Representative Form",
  supporting_statement: "Supporting Statement",
  independent_review_entity_response: "IRO/IRE Response",
  general_communication: "General Communication",
  external_review_case_summary: "External Review Case Summary",
};
